/**
 * DATA LAYER: KISS CAM OVERLAY
 * Se encarga de la comunicación HTTP con la API de Kiss Cam.
 */

export const GetKissConfig = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}kiss/config`);
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const SetKissConfig = async (config) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}kiss/config`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify(config)
        });
        if (!response.ok) return { success: false };
        const data = await response.json();
        return { success: true, data };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const ShowKissOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}kiss/show`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const HideKissOverlay = async () => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}kiss/hide`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};

export const TriggerKissAction = async (name, state = false) => {
    try {
        const response = await fetch(`${process.env.REACT_APP_API_URL}kiss/action?name=${name}&state=${state}`, { method: 'POST' });
        return { success: response.ok };
    } catch (error) {
        return { success: false, message: 'Error de conexión.' };
    }
};
export default { GetKissConfig, SetKissConfig, ShowKissOverlay, HideKissOverlay, TriggerKissAction }
